<template>
  <div class="container">
    <div class="login-card">
      <h1 class="login-title">Monitoring</h1>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <form class="login-form" @submit.prevent="login">
        <div class="form-group">
          <label for="username">Username</label>
          <input 
            id="username" 
            v-model="username" 
            type="text" 
            placeholder="Enter username" 
            autofocus
          />
        </div>
        
        <div class="form-group">
          <label for="password">Password</label>
          <input 
            id="password" 
            v-model="password" 
            type="password" 
            placeholder="Enter password" 
          />
        </div>
        
        <button type="submit" class="btn">
          {{ loading ? 'Logging in...' : 'Login' }}
        </button>
        
        <div class="divider">or</div>
        
        <button type="button" @click="keycloakLogin" class="btn btn-secondary">
          Keycloak SSO
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../api'

// Dictionary of error messages
const errorMessages = {
  'no_code': 'Authorization code missing',
  'token_error': 'Token error',
  'no_token': 'Server did not return an access token',
  'jwt_error': 'Token verification error',
  'client_error': 'Connection error with server',
  'server_error': 'Internal server error'
}

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      error: null,
      sessionUser: null
    }
  },
  created() {
    const fromRedirect = document.referrer.includes(window.location.origin) &&
                        document.referrer.includes('/login');
    
    if (fromRedirect) {
      return;
    }
    
    // Check URL for error parameter
    const urlParams = new URLSearchParams(window.location.search);
    const errorCode = urlParams.get('error');
    
    if (errorCode) {
      this.error = errorMessages[errorCode] || `Authentication error: ${errorCode}`;
      
      // Clear URL
      if (window.history.replaceState) {
        const url = window.location.href.split('?')[0];
        window.history.replaceState({}, document.title, url);
      }
    }
    
    // Check authentication status
    this.checkAuthStatus();
  },
  methods: {
    async login () {
      if (!this.username || !this.password) {
        this.error = 'Please fill in all fields'
        return
      }
      
      this.loading = true
      this.error = null
      
      try {
        const response = await api.post('/api/login', {
          username: this.username,
          password: this.password
        })
        
        // Save user to storage
        this.$store.commit('setUser', response.data.user)
        
        // Redirect to main page
        this.$router.push('/')
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          this.error = error.response.data.error
        } else {
          this.error = 'Login error. Please try again later.'
        }
      } finally {
        this.loading = false
      }
    },
    keycloakLogin() {
      this.loading = true;
      this.error = null;
      // Set flag before redirecting to Keycloak
      sessionStorage.setItem('keycloak_auth_redirect', 'true');
      window.location.href = '/auth/keycloak/auth';
    },
    // Function to display authentication status when page is loaded
    checkAuthStatus() {
      try {
        // Request to /api/auth-status to check authentication status
        api.get('/api/auth-status')
          .then(response => {
            if (response.data.error) {
              this.error = 'Session error: ' + response.data.error;
            }
            
            // Save authentication status
            const isAuthenticated = response.data.authenticated && response.data.user;
            if (isAuthenticated) {
              this.sessionUser = response.data.user;
              
              // Store user in state and redirect to home
              this.$store.commit('setUser', this.sessionUser);
              this.$router.push('/');
            }
          })
          .catch(error => {
            console.error('Error checking auth status:', error);
            this.error = 'Error checking authentication status';
          });
      } catch (error) {
        console.error('Error in checkAuthStatus:', error);
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 60px 15px;
  display: flex;
  justify-content: center;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background-color: white;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.login-title {
  margin: 0 0 20px;
  font-size: 24px;
  font-weight: normal;
  text-align: center;
}

.login-form {
  margin-top: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

.btn {
  width: 100%;
  padding: 10px;
  background-color: #264653;
  color: white;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}

.btn-secondary {
  background-color: #E76F51;
}

.error-message {
  background-color: #ffeeee;
  border: 1px solid #ffcccc;
  color: #cc0000;
  padding: 10px;
  margin-bottom: 15px;
}

.divider {
  text-align: center;
  margin: 15px 0;
  position: relative;
}

.divider:before,
.divider:after {
  content: "";
  position: absolute;
  top: 50%;
  height: 1px;
  background-color: #ddd;
  width: calc(50% - 20px);
}

.divider:before {
  left: 0;
}

.divider:after {
  right: 0;
}
</style> 